import { useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { useWebSockets } from 'src/contexts/webSocketsContext/websockets.context';
import { REPORTS_BUILD_PREFIX, REPORTS_HISTORY } from 'src/routes/config';

export const ReportNotificationHandler = ({ customerId }: { customerId: string }) => {
  const { enqueueSnackbar } = useSnackbar();
  const { reportNotificationIds, reportMessage, addReportNotificationId } = useWebSockets();

  useEffect(() => {
    if (!reportMessage?.data) return;
    if (reportMessage.messageType !== 'REPORT_GENERATION_COMPLETED') return;

    const reportId = reportMessage.data.id;

    if (!reportNotificationIds.has(reportId)) {
      addReportNotificationId(reportId);
      enqueueSnackbar(
        <span>
          Report has finished.{' '}
          <a
            href={`${window.location.origin}${REPORTS_BUILD_PREFIX}/${REPORTS_HISTORY}?customerId=${customerId}&templateId=${reportMessage.data.templateId}`}
            style={{ textDecoration: 'underline' }}
          >
            View report here
          </a>
        </span>,
        { variant: 'success' }
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportMessage, customerId]);

  return null;
};
